module.exports = function anonymous(it
/**/) {
var out='<div class="cols-l-6"> <div class="fragment fragment--style01 equal"> <a href="'+(it.DetailsLink)+'" class="fragment__row"> <div class="fragment__cell"> <div class="fragment__image fragment__image--small"> <img src="'+(it.Image)+'" alt="'+(it.Name)+'"> </div> <div class="fragment__content padding-t-sml padding-b-sml"> <div class="fragment-rte"> <h2 class="title-03">'+(it.Name)+'</h2> <p>'+(it.Description)+'</p> </div> </div> </div> </a> <div class="fragment__row"> <div class="fragment__cell"> <ul class="fragment__alt-ctas"> <li><a href="'+(it.DetailsLink)+'">Find out more</a></li> <li><a href="'+(it.BookingLink)+'">Book now</a></li> </ul> </div> </div> </div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/templates/course.dot
 ** module id = 278
 ** module chunks = 1
 **/